import { useEffect } from "react";
import { getPresentationParamsForOrigin } from "../getPresentationParamsForOrigin";

export const useDocumentTitle = (title: string | undefined) => {
  useEffect(() => {
    if (!title) return;

    const competitionName = getPresentationParamsForOrigin().competitionName;
    document.title = `${title} | ${competitionName}`;

    return () => {
      document.title = competitionName;
    };
  }, [title]);
};
